import React, { useEffect, useState } from "react";

import { Row, Col } from "react-bootstrap";

import UploadPres from "../components/UploadPrescription/UploadPres";

import AddressComp from "../components/Cart/AddressComp";
import {  useSelector } from "react-redux";
import { createOrderByPrescriptionOnly } from "../services/OrderService";

import { getLocalData } from "../utils/localStorage";


import OrderPlaced from "../static/Product/orderplaced.svg";
import { Link } from "react-router-dom";

import moment from "moment";

function UploadPrescription() {
  const [files, setFiles] = useState([]);

  const [isSideBarActive, setIsSideBarActive] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  
  const [shippingmethod, setshippingmethod] = useState("StorePickup");
  const [addressid, setaddressid] = useState(0);
  
  const [isOrderPlaced, setIsOrderPlaced] = useState(false);
  const [orderDetails, setOrderDetails] = useState(null);


  useEffect(() => {
    if (files.length > 0) {
      setIsSideBarActive(true); 
    } else {
      setIsSideBarActive(false);
    }
  }, [files]);


  const [orderItems, setOrderItems] = useState({
    "customerId": 0,
    "shippingAddressId": 0,
    "billingAddressId": 0,
    "outletId": 0,
    "prescriptionUrl": "string",
    "pictureId": 0,
    "shippingMethod": "string",
    "couponCode": "string",
    "hasPrescription": true,
    "orderByPrescription": true,
    "instruction": "",
    "prescriptionImageIds": [
      0
    ]
  });

  const handleInputChange = (e) => {
    const { value } = e.target;
    setOrderItems({
      ...orderItems,
      instruction: value,
    });

   
  };

  const userData = useSelector((state) => state.user.userData);
  const outletId =  getLocalData('outlet-id')

  const placeOrderWithPrescriptionOnly = () => { 

    let pictureIdArr = []
    files.forEach((file)=>{
      pictureIdArr.push(file.serverId);
    })
    let finalItems = {
      ...orderItems,
      customerId: userData.id,
      outletId: outletId,
      prescriptionImageIds : pictureIdArr,
      shippingMethod: shippingmethod,
      shippingAddressId: addressid
    }
  
    console.log(finalItems)

    createOrderByPrescriptionOnly(
      finalItems,
      getLocalData("user-info")?.userToken,
    ).then((data) => {
      setOrderDetails(data.data.response.data);
          if (data.data.status === "Success") {
            setIsOrderPlaced(true);
            
          }
    })
    .catch((err) => console.log(err));
  }

  return (
    <section className="space-at-top">
      {
        !isOrderPlaced && (
          <div className="container">
        <Row className="pb-2">
          <Col md={12}>
            <span className="header-1">Upload Prescription</span>
          </Col>
          <Row>
            <Col md={12} className="d-flex">
              <div>
                <Row>
                  <Col md={1}></Col>
                  <Col md={10}>
                    <div className="pd-name mt-5 mb-3">
                      Almost there.. Just upload a prescription for these meds
                      and we’re done!
                    </div>
                  </Col>
                  <Col md={1}></Col>
                  <Col md={12}>
                    <Row>
                      <Col md={1}></Col>
                      <Col md={10}>
                        <UploadPres files={files} setFiles={setFiles} setIsDisabled={setIsDisabled} />
                      </Col>
                      <Col md={1}></Col>
                    </Row>
                    {
                      isSideBarActive && (
                        <Row>
                        <Col md={1}></Col>
                        <Col md={10}>
                          <div className="form-group">
                            <label htmlFor="exampleFormControlTextarea1">Instructions</label>
                            <textarea 
                            className="form-control" 
                            id="exampleFormControlTextarea1" 
                            rows="3"
                            value={orderItems.instruction}
                          
                            onChange={handleInputChange}
                            ></textarea>
                          </div>
                        </Col>
                        <Col md={1}></Col>
                      </Row>
                      )
                    }
                    
                  </Col>
                  <Col md={1}></Col>
                  <Col md={10}>
                    <span className="pd-manufacturer-name">
                      The prescription must include appointment details and
                      shouldn’t be blurred or cropped. VIEW SAMPLE
                    </span>
                  </Col>
                  <Col md={1}></Col>
                </Row>
              </div>
              <div className={`left-menu ${isSideBarActive ? "open" : ""}`}>
                <Row>
                <Col md={12}>
                  
                    <div className="os-parent-button">
                     
                        <button
                         onClick={() => placeOrderWithPrescriptionOnly()}
                          className="btn pd-btn pd-atc"
                          disabled={isDisabled ? 'disabled': ''}
                        >
                          PLACE ORDER 
                        </button>
                      
                    </div>
                  </Col>
                  <Col md={12}>
                    <div className="os-parent-pymentmode">
                      Payment method:<span> Cash</span>
                    </div>
                  </Col>
                  <Col md={12}>
                    <div className="os-parent">
                      <AddressComp
                        setshippingmethod={setshippingmethod}
                        setaddressidtwo={setaddressid}
                      />
                    </div>
                  </Col>
                  <Col md={12}>
                    <div className="os-parent">
                    <Row>
                          <Col md={12}>
                            <Row>
                              <Col xs={12} md={12} className="os-header">
                                Order summary
                              </Col>
                            </Row>

                            <Row>
                              <Col xs={6} md={6} className="os-text">
                                Subtotal
                              </Col>
                              <Col xs={6} md={6} className="os-numbers">
                              To be decided
                              </Col>
                            </Row>
                            <Row>
                              <Col xs={6} md={6} className="os-text">
                                Standard Tax
                              </Col>
                              <Col xs={6} md={6} className="os-numbers">
                              To be decided
                              </Col>
                            </Row>
                            <Row>
                              <Col xs={6} md={6} className="os-text">
                                Discount
                              </Col>
                              <Col xs={6} md={6} className="os-numbers">
                              To be decided
                              </Col>
                            </Row>
                            <Row>
                              <Col xs={6} md={6} className="os-text">
                                Shipping Charges
                              </Col>
                              <Col xs={6} md={6} className="os-numbers">
                              To be decided
                              </Col>
                            </Row>

                            <Row className="os-gt-parent">
                              <Col xs={6} md={6} className="os-text">
                                Final Payable
                              </Col>
                              <Col xs={6} md={6} className="os-numbers">
                                To be decided
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Row>
      </div>
        )
      }
      
      {isOrderPlaced && (
        <div className="container">
          <Row>
            <Col md={12} className="text-center">
              <img src={OrderPlaced} alt="order-placed" />
            </Col>
            <Col md={12} className="text-center order-placed-heading mt-5 ">
              Order Placed
            </Col>
            <Col md={12} className="text-center order-placed-date ">
              on{" "}
              {moment(orderDetails.createdOnUtc).format("MMM DD, YYYY h:mm A")}
            </Col>
            <Col md={12} className="text-center order-placed-text mb-1">
              We are processing your order. We’ll ship your items really soon...
            </Col>
            <Col md={12} className="text-center order-placed-no">
              Order no. {orderDetails.id}
            </Col>
            <Col md={3} className="text-center"></Col>
            <Col md={3} className="text-center">
              <Link
                to={`/user/orderdetails/${orderDetails.id}`}
                className="btn pd-btn "
              >
                VIEW DETAILS
              </Link>
            </Col>
            <Col md={3} className="text-center">
              <Link to="/" className="btn pd-btn pd-atc">
                CONTINUE SHOPPING
              </Link>
            </Col>
            <Col md={3} className="text-center"></Col>
          </Row>
        </div>
      )}
    </section>
  );
}

export default UploadPrescription;
